import graphqlClient from "../../../apollo";

class CompanyConfigurationProvider {
  get() {
    return graphqlClient.query({
      query: require("./gql/companyConfigurationGet.graphql"),
      fetchPolicy: "network-only",
    });
  }

  update(variables) {
    return graphqlClient.mutate({
      mutation: require("./gql/companyConfigurationUpdate.graphql"),
      variables,
    });
  }
}

export default new CompanyConfigurationProvider();
